/// <reference path="../../../typings/index.d.ts" />

module Meevo {
  'use strict';

  export interface IContext extends ng.ui.IState {
    url: string;
    title: string;
    sticky: boolean;
    specialName: string;
    auditName?: string;
    isHomeContext: boolean;
    name: string;
    navigate(): void;
    close(): void;
    warnUponClose: boolean;
    navPresence: boolean;
    securityKey: string;
  }
}
